export enum VectorsDBIndexType {
    HnswEuclidean = 'hnsw_euclidean',
    HnswDot = 'hnsw_dot',
    HnswCosine = 'hnsw_cosine',
    Object = 'object',
    Key = 'key',
    Unique = 'unique',
}
